export default "__VITE_ASSET__BDU_P0EH__"